import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { TutorialMaterial } from '../../models/tutorial.model';
import { ActivatedRoute } from '@angular/router';
import { TutorialMaterialService } from '../../services/tutorial-class.service';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';
import { PdfViewerComponent } from 'ng2-pdf-viewer';
@Component({
  selector: 'app-tutorial-item-arquivo',
  templateUrl: './tutorial-item-arquivo.component.html',
  styleUrls: ['./tutorial-item-arquivo.component.scss', './../../tutorial.scss']
})
export class TutorialItemArquivoComponent extends BaseListComponent<TutorialMaterial> implements OnInit, OnDestroy {

  id:number;
  idClass:number;
  isAdmin:boolean;
  link:SafeResourceUrl = null;
  type:string = null;
  file:SafeResourceUrl = null;
  data: TutorialMaterial;

  @ViewChild(PdfViewerComponent, {static: false})
  private pdfComponent: PdfViewerComponent;
  
  constructor(
    private sanitizer: DomSanitizer,
    public activatedRoute: ActivatedRoute,
    private myService: TutorialMaterialService,
    private navigation: NavigationService
  ) { 
    super(); 
    
  }

  ngOnInit() {
    this.loading();
    this.id = this.activatedRoute.snapshot.params?.id;
    this.idClass = this.activatedRoute.snapshot.params?.idClass;
    var type = this.activatedRoute.snapshot.data['userType'];
    this.isAdmin = type == 'admin'? true: false;
    this.start();
  }

  ngOnDestroy() {
    if (this.file) {
        window.URL.revokeObjectURL(this.file.toString());
    }
  }

  getLink(url:string){
    //var url = 'https://www.youtube.com/watch?v=jNhBJDCih0o';
    var videoUrl = new URL(url);
    const urlParams = new URLSearchParams(videoUrl.search);
    const id = urlParams.get('v');
    this.link = this.sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + id);
  }
  start(): void {
    this.myService.getById(this.idClass).subscribe(
      (res) => {
        this.data = res;
        this.getType();
        this.loaded();
      },
      (error) => {
        this.msgError(error?.error?.message);
        this.loaded();
      },
    )
  }
  getType(){
    console.log(this.data)
    if(this.data.file_link != null){
      this.type = 'link';
      this.getLink(this.data.file_link);
    }
    else if(this.data.file_path != null){
      var fileExt = this.data.file_path.split('.').pop();
      switch (fileExt) {
       case 'pdf':
        this.type = 'application/pdf';
        break;
      case 'png':
      case 'jpg':
      case 'jpeg':
      case 'gif':
      case 'svg':
      case 'webp':
        this.type = 'image/png';
        break;
      default:
        this.type = null;
      }
      this.getFile();
    }
  }
  getFile():void{
    this.loading();
    this.myService.downloadFile(this.idClass).subscribe({
      next: (res) => {
        this.downloadFile(res);
      },
      error: (error) => {
        console.error('Erro ao baixar o arquivo:', error);
        this.loaded();
        this.msgError(error?.error.message);
      },
    });
  }

  downloadFile(res) {
    console.log(res)
    const blob = new Blob([res.body], { type: this.type });
    const url = window.URL.createObjectURL(blob);
    this.file = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.loaded();
  }

  download(){
    this.loading();
    const link = document.createElement('a');
    link.href = this.file.toString();
    link.download = this.data.file_name;
    link.click();
    this.loaded();
  }
  
  voltar(): void {
    var type = this.isAdmin == true? 'admin': 'user';
    this.navigation.back(['tutorial/' + type + '/'+ this.id]);
  }
}
